function getFirstFocusable(container) {
    return container.querySelector(`
        button,
        [href],
        input:not([type="hidden"]):not([disabled]),
        select:not([disabled]),
        textarea:not([disabled]),
        [tabindex]:not([tabindex="-1"])
    `);
}

export function initLoanPart(root) {
    const button = root.querySelector(".toggle");
    const checkbox = root.querySelector(".loan-checkbox");

    if (checkbox) {
        const checkboxHandler = () => {
            checkbox.checked
                ? root.classList.add("is-selected")
                : root.classList.remove("is-selected");
        };

        checkbox.addEventListener("change", checkboxHandler);
        checkboxHandler();
    }

    if (!button) return;

    const buttonLabelExpand = button.querySelector(".label-expand");
    const buttonLabelCollapse = button.querySelector(".label-collapse");

    const detailsId = button.getAttribute("aria-controls");
    if (!detailsId) return;

    const details = root.querySelector(`#${detailsId}`);
    if (!details) return;

    button.addEventListener("click", () => {
        const isExpanded = button.getAttribute("aria-expanded") === "true";
        const nextState = !isExpanded;

        nextState
            ? buttonLabelExpand.classList.add("hidden")
            : buttonLabelExpand.classList.remove("hidden");

        !nextState
            ? buttonLabelCollapse.classList.add("hidden")
            : buttonLabelCollapse.classList.remove("hidden");

        button.setAttribute("aria-expanded", String(nextState));
        details.hidden = !nextState;

        if (nextState) {
            const firstFocusable = getFirstFocusable(details);
            firstFocusable?.focus();
        }
    });
}